// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21t4P","comment":"styles_comment__1gkSe"};